import { checkReorderPointVsOrderUpTo } from './rules.js';
export function refineProduct(values, context) {
    // Mirrors setPartBrands and assertPartAcceptsProduct: a part sold as a product is that brand's alone.
    if (values.partBrandIds.length > 1) {
        context.addIssue({
            code: 'custom',
            message: "A part sold as a product belongs to that product's brand only. Keep one brand on this part, or skip the product.",
            path: ['productMode'],
        });
    }
    if (values.productMode === 'create') {
        if (!values.productNum.trim()) {
            context.addIssue({
                code: 'custom',
                message: 'Product number is required when creating a product.',
                path: ['productNum'],
            });
        }
        if (!values.productBrandId) {
            context.addIssue({
                code: 'custom',
                message: 'Brand is required when creating a product.',
                path: ['productBrandId'],
            });
        }
        else if (!values.partBrandIds.includes(values.productBrandId)) {
            context.addIssue({
                code: 'custom',
                message: "Choose one of the part's brands, since only they can stock it.",
                path: ['productBrandId'],
            });
        }
    }
}
export function refineLocation(values, context) {
    const hasGroup = Boolean(values.locationGroupId);
    const hasLocation = Boolean(values.locationId);
    const hasReorderValues = Boolean(values.reorderPoint.trim() || values.orderUpToLevel.trim());
    if (!hasGroup && (hasLocation || hasReorderValues)) {
        context.addIssue({
            code: 'custom',
            message: 'Select a warehouse before choosing a default location or setting reorder levels.',
            path: ['locationGroupId'],
        });
    }
    const reorderPoint = values.reorderPoint.trim() ? Number(values.reorderPoint) : null;
    const orderUpToLevel = values.orderUpToLevel.trim() ? Number(values.orderUpToLevel) : null;
    const reorderMessage = checkReorderPointVsOrderUpTo(reorderPoint, orderUpToLevel);
    if (reorderMessage) {
        context.addIssue({ code: 'custom', message: reorderMessage, path: ['reorderPoint'] });
    }
}
export function refineVendor(values, context) {
    if (values.vendorId && !values.vendorPartNumber.trim()) {
        context.addIssue({
            code: 'custom',
            message: 'Vendor part number is required when a vendor is selected.',
            path: ['vendorPartNumber'],
        });
    }
}
export function applyPartCreateWizardRefinements(values, context) {
    if (values.productMode !== 'none') {
        refineProduct(values, context);
    }
    refineLocation(values, context);
    refineVendor(values, context);
}
//# sourceMappingURL=create-form-refinements.js.map